import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from '../../../components/loading-spinner';
import {ReactComponent as ReactLogo} from '../../../button.svg';
import {searchProcessResultQuery, searchActivityItem, get_report, GET_REPORT, clear_activity, GET_REPORT_EXCEL, get_report_excel} from "../../../redux/activities";
// import {URLAPI} from "../../../config";
import Modal from "../../../components/modal";
import Button from "../../../components/button";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";

const ResultsQueryProcess = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const _get_report = useSelector((item) => item.activities_module._get_report);
    const _get_report_excel = useSelector((item) => item.activities_module._get_report_excel);

    const {id_hoja_trabajo, nombre, id_tienda, tienda, fecha_inicio, fecha_fin} = useParams();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [isLoading, setIsLoading] = useState(false);
    const [datas, setDatas] = useState({});
    const [item, setItem] = useState({});
    const [data, setData] = useState({});
    const [modalItem, setModalItem] = useState(false);
    const [modalActivities, setModalActivities] = useState(false);
    // const [jefe_zona, setJefeZona] = useState('');
    // const [correo_jefe_zona, setCorreoJefeZona] = useState('');


    useEffect(() => {
        getProcessResultsQuery();
        // eslint-disable-next-line
    }, [token, id_hoja_trabajo, nombre, id_tienda, fecha_inicio, fecha_fin]);

    async function getProcessResultsQuery() {
        setIsLoading(true);
        let params = '?id_hoja_trabajo=' + id_hoja_trabajo + '&&id_tienda=' + id_tienda + '&&fecha_inicio=' + fecha_inicio + '&&fecha_fin=' + fecha_fin;
        try {
            const response = await searchProcessResultQuery(token, params);
            if (response && response.data && response.data.datos) {
                setDatas(response.data.datos);
                // setJefeZona(response.data.tienda.jefe_zona);
                // setCorreoJefeZona(response.data.tienda.correo_jefe_zona);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getActivity(id_actividad) {
        setIsLoading(true);
        try {
            const response = await searchActivityItem(token, id_actividad);
            if (response && response.data && response.data.datos) {
                let v = response.data.datos;
                setData(v);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_activity(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_activity(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);
        // if (jefe_zona === '' || correo_jefe_zona === '') {
        //     toast.error("No se puede generar el reporte, debe configurar la información del jefe de zona", {position: toast.POSITION.TOP_RIGHT});
        //     setIsLoading(false);
        //     return;
        // }

        dispatch(get_report(token, 
            {
                'tiendas': [id_tienda], 
                'id_hoja_trabajo': id_hoja_trabajo, 
                'fecha_inicio': fecha_inicio, 
                'fecha_fin': fecha_fin,
                'tipo': 'TIENDA'
            }
        ));
    }

    useEffect(() => {
        if (_get_report_excel.status === 200) {
            toast.success(_get_report_excel.data.mensaje);
            dispatch(clear_activity(GET_REPORT_EXCEL));
            setIsLoading(false);
        } else if (_get_report_excel.status !== 0) {
            toast.error(_get_report_excel.message);
            dispatch(clear_activity(GET_REPORT_EXCEL));
            setIsLoading(false);
        }
    }, [_get_report_excel, dispatch])

    const handleGenerateReportExcel = (e) => {
        e.preventDefault();
        setIsLoading(true);

        dispatch(get_report_excel(token, 
            {
                'id_tienda': id_tienda, 
                'id_hoja_trabajo': id_hoja_trabajo, 
                'fecha_inicio': fecha_inicio, 
                'fecha_fin': fecha_fin,
            }
        ));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hoja de trabajo"
                            items={[{label: "Consulta de resultados", link: "/consulta-resultados"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="d-flex">
                                    <div style={{cursor: 'pointer'}} onClick={() => {
                                        history.push(`/resultado/${id_hoja_trabajo}/${nombre}/${id_tienda}/${tienda}/${fecha_inicio}/${fecha_fin}`);
                                    }}>
                                        <ReactLogo width={50} heght={40}/>
                                    </div>
                                    <p className="ml-1" style={{marginTop: 5, fontSize: 18, color: '#727E8C'}}>Detalle de {nombre}</p>
                                </div>
                                <div className="border_card row" style={{background: data.color_div}}>
                                    <div className='col-md-8 col-sm-12'>
                                        <div className="d-flex">
                                            <p style={{marginRight: 15}}>
                                                <small>Fecha de inicio</small><br/>
                                                <strong>{datas.fecha_inicio}</strong>
                                            </p>
                                            <p style={{marginRight: 15}}>
                                                <small>Fecha de fin</small><br/>
                                                <strong>{datas.fecha_final}</strong>
                                            </p>
                                            <p style={{marginRight: 15}}>
                                                <small>Tienda</small><br/>
                                                <strong>{datas.tienda}</strong>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-12 text-right mt-md-1">
                                        <Button type="button" text="Exportar" theme="calendar" onClick={handleGenerateReportExcel} style={{marginRight: 5}}/>
                                        <Button type="button" text="Enviar jefe zonal" theme="calendar" onClick={handleGenerateReport}/>
                                    </div>
                                </div>
                                <div className="mt-1">
                                    {datas.procesos &&
                                        <div className="border_card">
                                            <h5>Resumen de evaluación de cumplimiento</h5>
                                            <table width={'100%'}>
                                                {datas.procesos.map(po => (
                                                    <tr>
                                                        <th>{po.nombre_proceso}</th>
                                                        <th className="text-right">{po.porcentaje} %</th>
                                                    </tr>
                                                ))}
                                            </table>
                                        </div>
                                    }
                                    {datas.procesos &&
                                        datas.procesos.map(p => (
                                            <div className="mt-2">
                                                <strong className="texto_18">{p.nombre_proceso}: {p.porcentaje}%</strong>
                                                {(p.actividades && p.actividades.length > 0) && 
                                                    p.actividades.map(a => (
                                                        <div className="table-responsive">
                                                            <table className="table border_card">
                                                                <tr>
                                                                    <td style={{width: '22%'}}>
                                                                        <small>Nombre de subproceso</small><br/>
                                                                        <strong>{a.subproceso}</strong>
                                                                    </td>
                                                                    <td style={{width: '22%'}}>
                                                                        <small>Nombre de actividad</small><br/>
                                                                        <strong>{a.actividad}</strong>
                                                                    </td>
                                                                    <td style={{width: '20%'}}>
                                                                        <small>Criticidad</small><br/>
                                                                        <strong>{a.criticidad}</strong>
                                                                    </td>
                                                                    <td style={{width: '20%'}}>
                                                                        <small>Estado</small><br/>
                                                                        <strong style={{color: a.color, background: a.background, padding: '2px 5px'}}>{a.estado}</strong>
                                                                    </td>
                                                                    <td style={{width: '16%'}}>
                                                                        {(a.actividades.length > 0) &&
                                                                            <strong style={{cursor: 'pointer'}} onClick={() => {
                                                                                setModalActivities(true);
                                                                                setItem(a);
                                                                                // setData({});
                                                                                // getActivity(a.id_actividad);
                                                                                // setModalItem(true);
                                                                            }}>Ver resultados</strong>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>    
                                                    ))
                                                }
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modalActivities}>
                <div className="card-body">
                    <h5>Actividades</h5>
                    <div className="">
                        <table className="table border_card">
                            {(item && item.actividades) && 
                                item.actividades.map(a => (
                                    <tr>
                                        <td>
                                            <small>Actividad</small><br/>
                                            <strong>{a.actividad}</strong>
                                        </td>
                                        <td>
                                            <small>Criticidad</small><br/>
                                            <strong>{a.criticidad}</strong>
                                        </td>
                                        <td>
                                            <small>Estado</small><br/>
                                            <strong style={{color: a.color}}>{a.estado}</strong>
                                        </td>
                                        <td>
                                            {a.estado !== '' &&
                                                <strong style={{cursor: 'pointer', fontSize: 12}} onClick={() => {
                                                    setData({});
                                                    getActivity(a.id_actividad);
                                                    setModalItem(true);
                                                }}>Ver resultados</strong>
                                            }
                                        </td>
                                    </tr>
                                ))
                            }
                        </table>
                    </div>
                    <div className="card-footer text-center">
                        <button type="button" onClick={() => {
                            setModalActivities(false);
                        }} className={`btn btn-calendar button_div`}>Atrás
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal className="modal-main div-modal" show={modalItem}>
                <div className="card-body">
                    <h5 className="titulo_modal type_text mb-1">Datos de actividad</h5>
                    <div style={{background: data.color_div, padding: 5, cursor: 'pointer'}} className="d-flex mb-1">
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Fecha agendada</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.fecha_agendada}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Estado actividad</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.estado}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Realizado por</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.usuario}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Tienda</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.tienda}</strong>
                        </div>
                        <div className="ml-1">
                            <span className="texto_10" style={{color: data.color}}>Estado resultado</span><br/>
                            <strong className="texto_14" style={{color: data.color}}>{data.estado_resultado}</strong>
                        </div>
                    </div>
                    {(data && data.resultados && data.resultados.length > 0) && 
                        <div className="mt-1">
                            <p className="texto_16">Archivos de resultados</p>
                            {data.resultados.map((_) => (
                                <div className="d-flex border_card">
                                    <div style={{width: '60%'}} className="ml-1">
                                        <span className="texto_14">{_.nombre_template}</span><br/>
                                        {!_.archivo ?
                                                <span className="texto_14">Pendiente</span>
                                            :
                                                <span className="texto_14">Cargado</span>
                                        }
                                    </div>
                                    <div className="text-right" style={{width: '40%'}}>
                                        {_.archivo &&
                                            <>
                                                {/*eslint-disable-next-line*/}
                                                <a href={_.archivo} target="_blank" className="ml-1">Descargar</a>
                                            </>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    {(data && data.imagenes && data.imagenes.length > 0) && 
                        <div className="mt-1">
                            <p className="texto_16">Fotografías de evidencia</p>
                            <div className="border_card d-flex">
                                {data.imagenes.map((_) => (
                                    <div className="text-center mr-1" style={{width: '30%'}}>
                                        <img
                                            src={_.imagen}
                                            width={100}
                                            height={90}
                                            alt={_.nombre}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                    <div className="mt-1">
                        <p className="texto_16">Observaciones finales</p>
                        <div className="border_card row">
                            <div className="col-6">
                                <span className="texto_14">Observacón final</span>
                                <p className="border_card">{data.observacion}</p>
                            </div>
                            <div className="col-6">
                                <span className="texto_14">Riesgo</span>
                                <p className="border_card">{data.riesgo}</p>
                            </div>
                            <div className="col-6">
                                <span className="texto_14">Responsable</span>
                                {(data && data.responsables && data.responsables.length > 0) &&
                                    <p className="border_card">
                                        {data.responsables.map((r) => (
                                            <>
                                                <span>{r.nombre}</span> 
                                                <br/>
                                            </>
                                        ))}
                                    </p>
                                }
                            </div>
                            <div className="col-6">
                                <span className="texto_14">Notificado a administración</span>
                                <p className="border_card">NO</p>
                            </div>
                            <div className="col-12">
                                <span className="texto_14">Comentario</span>
                                <p className="border_card">{data.comentario}</p>
                            </div>
                        </div>
                    </div>
                    {(data && data.adicionales && data.adicionales.length > 0) && 
                        <div className="mt-1">
                            <p className="texto_16">Datos adicionales</p>
                            <div className="border_card row">
                                {data.adicionales.map((_) => (
                                    <div className="col-6">
                                        <span className="texto_14">{_.label}</span>
                                        <p className="border_card">{_.value}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                    {data && data.impacto_riesgo &&
                        <div className="mt-1">
                            <p className="texto_16">Impacto del riesgo</p>
                            <div className="border_card row">
                                <div className="col-6">
                                    <span className="texto_14">Clasificación</span>
                                    <p className="border_card">{data.descripcion_impacto_riesgo}</p>
                                </div>
                                <div className="col-6">
                                    <span className="texto_14">Valor</span>
                                    <p className="border_card">{data.valor_impacto_riesgo}</p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="card-footer text-center">
                    <button type="button" onClick={() => {
                        setModalItem(false);
                    }} className={`btn btn-calendar button_div`}>Atrás
                    </button>
                </div>
            </Modal>
            <Footer/>
        </div>
    );
};

export default ResultsQueryProcess;
